/**
 * Template e snippet per articoli UNASCA
 * Utilizzati nell'editor TinyMCE per inserire rapidamente elementi stilizzati
 */

export const articleTemplates = [
  {
    title: '📰 Articolo Completo',
    description: 'Template completo con tutti gli elementi',
    content: `
<div class="unasca-article">
  <span class="kicker">CATEGORIA</span>
  <h1>Titolo dell'Articolo</h1>
  <p class="lead">Introduzione accattivante che riassume il contenuto principale dell'articolo in 2-3 righe.</p>
  <p class="meta">Autore • Data • 5 min di lettura</p>
  <div class="sep"></div>
  
  <div class="keypoints">
    <h3>📌 Punti Chiave</h3>
    <ul>
      <li>Primo punto importante</li>
      <li>Secondo punto importante</li>
      <li>Terzo punto importante</li>
    </ul>
  </div>
  
  <h2>Primo Paragrafo</h2>
  <p>Contenuto del primo paragrafo...</p>
  
  <div class="callout">
    <p><strong>💡 Nota Importante:</strong> Informazione rilevante che merita attenzione.</p>
  </div>
  
  <h2>Secondo Paragrafo</h2>
  <p>Contenuto del secondo paragrafo...</p>
  
  <blockquote>
    <p>"Una citazione interessante che aggiunge valore all'articolo."</p>
  </blockquote>
  
  <div class="foot">
    <p>Articolo pubblicato il [DATA] • Ultima modifica: [DATA]</p>
  </div>
</div>
    `
  },
  {
    title: '🎯 Box Punti Chiave',
    description: 'Box evidenziato con punti chiave',
    content: `
<div class="keypoints">
  <h3>📌 Punti Chiave</h3>
  <ul>
    <li>Primo punto importante</li>
    <li>Secondo punto importante</li>
    <li>Terzo punto importante</li>
  </ul>
</div>
    `
  },
  {
    title: '💡 Callout / Nota',
    description: 'Box evidenziato per note importanti',
    content: `
<div class="callout">
  <p><strong>💡 Nota Importante:</strong> Inserisci qui il testo della nota.</p>
</div>
    `
  },
  {
    title: '💬 Citazione',
    description: 'Blockquote stilizzato',
    content: `
<blockquote>
  <p>"Inserisci qui la citazione."</p>
</blockquote>
    `
  },
  {
    title: '🏷️ Badge',
    description: 'Badge colorato per tag o categorie',
    content: `<span class="badge">NUOVO</span>`
  },
  {
    title: '📝 Kicker + Titolo',
    description: 'Intestazione con categoria e titolo',
    content: `
<span class="kicker">CATEGORIA</span>
<h1>Titolo dell'Articolo</h1>
<p class="lead">Introduzione accattivante dell'articolo.</p>
    `
  },
  {
    title: '➖ Separatore',
    description: 'Linea separatrice',
    content: `<div class="sep"></div>`
  }
];

// Snippet per il menu "Insert" di TinyMCE
export const articleSnippets = {
  kicker: '<span class="kicker">CATEGORIA</span>',
  lead: '<p class="lead">Testo introduttivo...</p>',
  meta: '<p class="meta">Autore • Data • Tempo di lettura</p>',
  separator: '<div class="sep"></div>',
  keypoints: `
<div class="keypoints">
  <h3>📌 Punti Chiave</h3>
  <ul>
    <li>Punto 1</li>
    <li>Punto 2</li>
    <li>Punto 3</li>
  </ul>
</div>`,
  callout: `
<div class="callout">
  <p><strong>💡 Nota:</strong> Testo della nota.</p>
</div>`,
  badge: '<span class="badge">TESTO</span>',
  footer: `
<div class="foot">
  <p>Informazioni aggiuntive...</p>
</div>`
};

// Stili CSS da iniettare nell'editor TinyMCE per l'anteprima
export const editorStyles = `
.unasca-article { --radius: 16px; color: #0f172a; font: 16px/1.7 system-ui; }
.unasca-article { --ink: #0f172a; --muted: #475569; --accent: #1e40af; --rule: #e5e7eb; --soft: #eef2ff; --soft-border: #c7d2fe; --blockquote-bg: #f9fafb; --blockquote-border: #cbd5e1; --callout-bg: #f8fafc; --badge-bg: #eef2ff; --badge-border: #c7d2fe; --badge-text: #1e3a8a; }
.unasca-article .kicker { display: inline-block; text-transform: uppercase; letter-spacing: .08em; font-weight: 700; font-size: .78rem; color: var(--accent); margin-bottom: .4rem; }
.unasca-article h1 { font-weight: 800; line-height: 1.15; font-size: clamp(1.9rem, 3.6vw, 2.6rem); margin: .2rem 0 .6rem; color: var(--ink); }
.unasca-article .lead { font-size: clamp(1.05rem, 1.4vw, 1.25rem); opacity: .92; margin: .4rem 0 1rem; color: var(--ink); }
.unasca-article .meta { color: var(--muted); font-size: .95rem; margin-bottom: 1rem; }
.unasca-article .sep { height: 1px; background: var(--rule); margin: 1rem 0; }
.unasca-article p { margin: 0 0 1rem; color: var(--ink); }
.unasca-article a { color: var(--accent); }
.unasca-article .keypoints { background: var(--soft); border: 1px solid var(--soft-border); border-radius: var(--radius); padding: 1rem; margin: 1.25rem 0; }
.unasca-article .keypoints * { color: var(--ink) !important; }
.unasca-article .keypoints h3 { margin: .2rem 0 .4rem; font-size: 1rem; font-weight: 700; }
.unasca-article .keypoints ul { margin: .2rem 0 0 1.2rem; }
.unasca-article .keypoints li { margin: .4rem 0; }
.unasca-article h2 { margin: 1.6rem 0 .6rem; font-size: 1.35rem; color: var(--ink); }
.unasca-article h3 { margin: 1.2rem 0 .4rem; font-size: 1.1rem; color: var(--ink); }
.unasca-article blockquote { margin: 1rem 0; padding: .9rem 1rem; border-left: 4px solid var(--blockquote-border); background: var(--blockquote-bg); border-radius: 10px; font-style: italic; color: var(--ink); }
.unasca-article .callout { border-left: 4px solid var(--accent); background: var(--callout-bg); border: 1px solid var(--rule); border-radius: 10px; padding: 1rem; margin: 1rem 0; }
.unasca-article .callout * { color: var(--ink) !important; }
.unasca-article .badge { display: inline-block; background: var(--badge-bg); border: 1px solid var(--badge-border); color: var(--badge-text); padding: .35rem .6rem; border-radius: 999px; font-size: .85rem; font-weight: 700; margin-right: .5rem; }
.unasca-article .foot { border-top: 1px solid var(--rule); margin-top: 1.5rem; padding-top: .8rem; color: var(--muted); font-size: .95rem; }
`;

